import cssClasses from '../helpers/cssClasses';
import {on} from '../helpers/utils';

// DOM Selectors
const selectors = {
  container: '[ks-readmore="container"]',
  content: '[ks-readmore="content"]',
  trigger: '[ks-readmore="trigger"]',
};

export default () => {
  // Node selectors
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    containerExpand: document.querySelector(selectors.content),
    trigger: document.querySelector(selectors.trigger),
  };

  // Set listeners
  function setListeners() {
    if (!nodeSelectors.trigger) {
      return;
    }

    on('click', nodeSelectors.trigger, (event) => handleToggle(event));

    // console.log('Katies Story');
  }

  // Open + Close toggles
  function handleToggle(event) {
    event.preventDefault();

    if (nodeSelectors.trigger.classList.contains(cssClasses.active)) {
      removeActiveState();
      removeHeight();
    } else {
      addActiveState();
      addHeight();
    }
  }

  function addActiveState() {
    nodeSelectors.container.classList.add(cssClasses.active);
    nodeSelectors.trigger.classList.add(cssClasses.active);
  }

  function addHeight() {
    const {clientHeight} = document.querySelector('[ks-readmore="content"]');
    nodeSelectors.container.setAttribute('style', `height:${clientHeight}px`);
  }

  function removeActiveState() {
    nodeSelectors.container.classList.remove(cssClasses.active);
    nodeSelectors.trigger.classList.remove(cssClasses.active);
  }

  function removeHeight() {
    nodeSelectors.container.setAttribute('style', `height: "inherit"`);
  }

  function init() {
    setListeners();
  }

  // Public interface
  return Object.freeze({
    init,
  });
};
